module.exports = __webpack_public_path__ + "static/img/T24_03_13.c06642f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/T24_03_13.png
// module id = O9Q1
// module chunks = 41